import { render } from "./TeacherPanel.vue?vue&type=template&id=4e4b0450&scoped=true"
import script from "./TeacherPanel.vue?vue&type=script&lang=js"
export * from "./TeacherPanel.vue?vue&type=script&lang=js"

import "./TeacherPanel.vue?vue&type=style&index=0&id=4e4b0450&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4b0450"]])

export default __exports__